import { render, staticRenderFns } from "./teampay.vue?vue&type=template&id=66835225&scoped=true&"
import script from "./teampay.vue?vue&type=script&lang=js&"
export * from "./teampay.vue?vue&type=script&lang=js&"
import style0 from "./teampay.vue?vue&type=style&index=0&id=66835225&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66835225",
  null
  
)

export default component.exports